'use strict';
import { module } from '../app';
import { stateData } from "./stateData";
import { ClipBoardDetailDialogModel } from './clipboardDetail';
import { constantStrings } from "../constants/constantStrings";
import { CANNED_NOTES_FLAG_ID } from '../constants/worklist-constants';
import * as commonConstants from '../constants/constantStrings';
import { StudyDisplayHelpers } from '../helpers/studyDisplayHelpers';

module
  .factory('patientDetailsViewModel', [
    '$state', '$filter', 'Patient', 'ionicDatePicker', 'Magview',
    'techpadConfig', 'modalService', '$ionicLoading', 'signalrService',
    'Lookups', 'PatientReferringPhysiciansDialogModel',
    'localStorage', 'techpadOptions', 'environmentHelper', 'ageHelper',
    'Study', 'Worklist', 'FollowUpsDomain', 'enums', 'documentsSvc',
    'techpadInitialConfigProvider', '$rootScope', 'documentPrintHelper',
    function ($state, $filter, Patient, ionicDatePicker, Magview,
       techpadConfig, modalService, $ionicLoading, signalrService,
       Lookups, PatientReferringPhysiciansDialogModel,
       localStorage, techpadOptions, environmentHelper, ageHelper,
       Study, Worklist, FollowUpsDomain, enums, documentsSvc,
       techpadInitialConfigProvider, $rootScope, documentPrintHelper) {

      function patientDetailsViewModel(accessToken, isViewOnly) {

        const DEFAULT_MIN_DATE_STRING = '0001-01-01T00:00:00';
        const PATIENT_CLIPBOARD_TITLE = 'Patient Clipboard';
        const SAVING_PATIENT_DETAILS_LOADER_MESSAGE = 'Saving patient details...';

        let self = this;

        self.tabs = {
          Patient: 1,
          Studies: 2
        };

        self.procTypes = enums.procTypes;

        self.tab = 0;
        self.ssn = null;
        self.accessToken = accessToken;

        self.isIOSDevice = environmentHelper.isIOSDevice();
        self.isOnline = () => signalrService.isConnected;

        self.changeTab = function (tab) {
          if (tab === self.tab) {
            return;
          }

          self.tab = tab;
        };

        self.showValidationErrors = false;

        self.techpadSettings = techpadConfig.settings;

        self.techpadConfig = techpadConfig;

        self.isViewOnly = isViewOnly || !self.techpadSettings.IsAllowedToChangePatientsData;

        techpadOptions.getOptions();

        self.darkMode = techpadOptions.options.DarkMode;

        self.statesList = stateData;
        self.citiesList = [];
        self.zipCodesList = [];
        self.visitReasons = [];
        self.isCheckingEmailExist = false;

        self.ClipboardFlagTitle = null;
        self.ClipboardFlagTitleCopy = null;
        self.patClipPref = {
          AllowModifyPatClip: false,
          AllowModifyPatClipNote: false
        };
        self.viewsTypes = [...enums.viewsTypes];

        if (!techpadConfig.settings.TomoViews) {
          self.viewsTypes = self.viewsTypes.filter(type => type.Key !== 'T');
        }
        if (techpadConfig.settings.HideMag) {
          self.viewsTypes = self.viewsTypes.filter(type => type.Key !== 'M');
        }

        self.initializeData = async function () {
          self.loading = true;
          $ionicLoading.show({
            template: constantStrings.DefaultLoaderMessage
          });

          if (self.accessToken) {
            await self.getPatientData();
            self.ClipboardFlagTitleCopy = angular.copy(self.ClipboardFlagTitle);
            if (self.patient.State && self.patient.City) {
              self.getCitiesList(self.patient.State);
            }
          } else {
            await self.preparePatientData();
          }

          self.races = (await Lookups.getRaces()).data;
          self.languages = (await Lookups.getLanguages()).data;

          await self.getPatClipSetting();

          await self.loadLocations();
          await self.loadStudies();
          await self.setStudies();

          self.loading = false;
          $ionicLoading.hide();
        };

        self.changeState = function (stateCode) {
          self.patient.City = "";
          self.citiesList = [];
          if (stateCode) {
            self.getCitiesList(stateCode);
          }
          self.patient.Zip = "";
        };

        self.getPatClipSetting = async function () {
          var userLogin = localStorage.get('UserLogin');
          const response = await Patient.getPatClipSetting(userLogin);
          self.patClipPref = response.data;
        }

        self.getCitiesList = async function (stateCode) {
          const response = await Patient.getCitiesByState(stateCode).catch(error => {
            let message = error.errorId ? 'Error ID: ' + error.errorId + '. ' : '';
            modalService.showErrorMessage(message + (error.message || error.exception && error.exception.Message));
          });
          self.citiesList = response.data.Cities;
          if (self.patient.City) {
            self.changeCity(self.patient.City);
          }
        };

        self.changeCity = function (city) {
          self.getZipCodesList(city);
        };

        self.getZipCodesList = function (city) {
          self.zipCodesList = [];
          const cityData = self.citiesList.find(item => item.Name === city);
          if (!cityData || !cityData.ZipCodes.includes(self.patient.Zip)) {
            self.patient.Zip = '';
          }
          self.zipCodesList = cityData && cityData.ZipCodes && cityData.ZipCodes.length ? _.map(cityData.ZipCodes, function (zipCode) {
            return { code: zipCode };
          }) : [];
        };

        self.fillStateCity = async function () {
          if (self.patient.Zip.length > 4 && (!self.zipCodesList || !self.zipCodesList.includes(self.patient.Zip))) {
            const res = await Patient.getCitiStateByZip(self.patient.Zip);
            if (res.data && res.data.State && res.data.City && res.data.Zipcode) {
              self.patient.City = res.data.City;
              self.patient.State = res.data.State;
              await self.getCitiesList(res.data.State);
              self.patient.Zip = res.data.Zipcode;
              document.activeElement.blur();
            }
          }
        };

        self.getPatientDOBAsDate = function () {
          if (self.patient.DOB instanceof Date) {
            return self.patient.DOB;
          }
          let dobString = self.patient.DOB.toString().split("T")[0];
          let year = parseInt(dobString.toString().split("-")[0]);
          let month = parseInt(dobString.toString().split("-")[1]) - 1;
          let day = parseInt(dobString.toString().split("-")[2]);
          return new Date(year, month, day);
        }

        self.getPatientData = async function () {
          const resp = await Patient.getPatientDetailsByAccessToken(self.accessToken);
          self.patient = resp.data;
          self.ssn = self.patient.Ssn;
          self.patientCopy = angular.copy(self.patient);
          if (self.patient.DOB) {
            self.patient.DOB = self.getPatientDOBAsDate();
          }

          self.changeTab(self.tabs.Patient);

          this.ClipboardFlagTitle = self.patient.ClipboardFlag;

          try {
            const letterTypeModel = await Patient.loadLetterType(self.ssn);
            resp.data.LetterTypeConfig = letterTypeModel.data.letterTypeConfig;
            resp.data.LetterTypeAnswer = letterTypeModel.data.letterTypeAnswer;
            const options = [{
              Code: "",
              Desc: "English"
            }];
            resp.data.LetterTypeConfig.Options = options.concat(resp.data.LetterTypeConfig.Options);
            if (!resp.data.LetterTypeAnswer) {
              resp.data.LetterTypeAnswer = {
                Code: ''
              };
            }
            if (resp.data.LetterTypeAnswer.Code === 'Default') {
              resp.data.LetterTypeAnswer.Code = '';
            }
            resp.data.LetterTypeAnswer.Desc = resp.data.LetterTypeConfig.Options.find(x => x.Code ===
              resp.data.LetterTypeAnswer.Code).Desc;
            self.patient = resp.data;
            self.patientCopy = angular.copy(self.patient);
            if (self.patient.DOB) {
              self.patient.DOB = self.getPatientDOBAsDate();
            }
            self.changeTab(self.tabs.Patient);
          } catch (error) {
            self.loading = false;
            $ionicLoading.hide();
            await modalService.showErrorMessage(error.data);
          }
        };

        self.preparePatientData = async function () {
          try {
            const resp = await Patient.getLetterTypeConfig();
            const letterTypeConfig = resp.data.letterTypeConfig;
            self.patient = {
              LetterTypeAnswer: {
                Code: ""
              },
              LetterTypeConfig: letterTypeConfig
            };
            const options = [{
              Code: "",
              Desc: "English"
            }];
            self.patient.LetterTypeConfig.Options = options.concat(letterTypeConfig.Options);
            self.loading = false;
            //$ionicLoading.hide();
            self.changeTab(self.tabs.Patient);
          } catch (error) {
            $ionicLoading.hide();
            self.changeTab(self.tabs.Patient);
            await modalService.showErrorMessage(error.data);
          }
        };

        self.isEmailInUse = async function () {
          let isEmailInUse = false;
          const isEmailSet = self.patient.Email && (!self.patientCopy || self.patientCopy.Email !== self.patient.Email);
          if (isEmailSet) {
            const checkPatientEmailResp = await Patient.checkPatientEmail(self.patient.Email);
            isEmailInUse = checkPatientEmailResp && checkPatientEmailResp.data === true;
            if (isEmailInUse) {
              modalService.showAlert(constantStrings.DefaultEmailInUseAlertMessage);
            }
          }
          return isEmailInUse;
        }

        self.savePatientDetails = async function (data, skipRedirecting, callback) {
          let isSucceess = true;
          try {
            $ionicLoading.show({
              template: 'Saving patient details...'
            });
            let data = angular.copy(self.patient);
            data.DOB = $filter('date')(self.patient.DOB, 'MM/dd/yyyy');
            data.useAlternativeUserIdentifier = self.techpadSettings.UseAlternateUserIdentifier;

            let resp = null;
            try {
              resp = await Patient.post(data);
              if (!self.ssn) {
                self.ssn = resp.data.Ssn;
              }
              if (!skipRedirecting) {
                $state.go('root.patient_details', {ssn: self.ssn});
              } else if (callback) {
                callback && typeof callback === "function" && callback();
              }
              self.wasSaved = true;
            } catch (error) {
              $ionicLoading.hide();
              await modalService.showErrorMessage(error.data);
              isSucceess = false;
            }
            self.wasSaved = true;
          } catch (error) {
            $ionicLoading.hide();
            await modalService.showErrorMessage(error.data);
            isSucceess = false;
          }
          return isSucceess
        }

        self.save = async function (skipRedirecting, callback) {
          const isOffline = await self.checkIfOffline();
          if (isOffline) {
            return;
          }

          const isValid = self.validate();
          if (isValid) {
            const isEmailInUse = await self.isEmailInUse();
            if (!isEmailInUse) {
              $ionicLoading.show({ template: SAVING_PATIENT_DETAILS_LOADER_MESSAGE });
              let data = angular.copy(self.patient);
              data.DOB = $filter(constantStrings.DATE_OBJECT_TYPE)(self.patient.DOB, constantStrings.DefaultStudyDateFormat);
              data.useAlternativeUserIdentifier = self.techpadSettings.UseAlternateUserIdentifier;

              const isSuccess = await self.savePatientDetails(data, skipRedirecting, callback);
              if (isSuccess) {
                try {
                  await Patient.saveLetterTypeAnswer(data.LetterTypeAnswer, self.ssn);
                  await self.getPatientData();
                  $ionicLoading.hide();
                } catch (error) {
                  $ionicLoading.hide();
                  await modalService.showErrorMessage(error.data);
                }
              }
            }
          } else {
            self.showValidationErrors = true;
          }
        };

        self.clipboardClicked = async function () {
          const isOffline = await self.checkIfOffline();
          if (isOffline){
            this.loading = false;
            return;
          }
          try {
            if (this.loading == true) {
              return;
            }

            this.loading = true;
            $ionicLoading.show({
              template: constantStrings.DefaultLoaderMessage
            });

            const resp = await Patient.loadPatClip(self.ssn);
            let patClips = resp.data;
            let data = {};

            if (!patClips || patClips.length === 0) {
              data = self.createEmptyPatClipItem();
            } else {
              let patClip = _.find(patClips, function (item) {
                return !item.IsClipNote || !item.Type;
              });

              if (!patClip) {
                patClip = self.createEmptyPatClipItem();
              }

              const patClipNotes = _.filter(patClips, function (item) {
                return item.IsClipNote === true;
              });

              if (patClip.ExpDate === DEFAULT_MIN_DATE_STRING) {
                patClip.ExpDate = null;
              }

              if (!patClip) {
                patClip = self.createEmptyPatClipItem();
              }

              data = patClip;
              self.ClipboardFlagTitle = data.Flag;
              data.PatientNotes = patClipNotes;
            }

            let modalConfig = {};
            let editMode = false;
            let title = PATIENT_CLIPBOARD_TITLE;

            $ionicLoading.hide();

            let model = new ClipBoardDetailDialogModel(modalConfig, data, editMode, title, self.ssn, Patient,
              Magview, localStorage, self.patClipPref, self.isViewOnly, self.checkIfOffline, techpadConfig.settings.CannedNotes.filter(x => x.CommentId === CANNED_NOTES_FLAG_ID));
            await modalService.showDialogWindow('views/templates/clipboardDialog.html', model, true);
            self.ClipboardFlagTitle = data.Flag;

            this.loading = false;
          } catch (error) {
            this.loading = false;
            $ionicLoading.hide();
            await modalService.showErrorMessage(error.data);
          }
        }

        self.showPatClipPopup = function () {
          modalService.showAlert(self.ClipboardFlagTitle);
        };

        self.createEmptyPatClipItem = function () {
          var data = {
            Id: null,
            SSN: self.ssn,
            Clip: '',
            Clipboard: '',
            Type: '',
            CNum: 0,
            NoteNum: 0,
            ExpDate: null,
            ADate: null,
            AUser: null,
            MDate: null,
            MUser: null,
            PatientNotes: []
          };
          return data;
        }

        self.validateAndSave = async function () {
          const isOffline = await self.checkIfOffline();
          if (isOffline) {
            return;
          }

          if (self.accessToken) {
            if (self.checkForChanges()) {
              modalService.showConfirmation(null, constantStrings.DefaultRevertChangesConfirmationMessage)
                .then((resp) => {
                  if (resp) {
                    $state.go('root.study_details', { accessToken: self.accessToken });
                  }
                });
            } else {
              $state.go('root.study_details', { accessToken: self.accessToken });
            }
          } else {
            self.showValidationErrors = true;
          }
        };

        self.validateAndOpenStudy = async function (sdate) {
          const isOffline = await self.checkIfOffline();
          if (isOffline) {
            return;
          }

          if (self.checkForChanges()) {
            modalService.showConfirmation(null, constantStrings.DefaultRevertChangesConfirmationMessage)
              .then((confirmed) => {
                if (confirmed) {
                  $state.go('root.study_details', {
                    accessToken: self.accessToken,
                    sdate: $filter(constantStrings.DATE_OBJECT_TYPE)(sdate, constantStrings.DefaultStudyDateUrlFormat)
                  });
                }
              });
          } else {
            $state.go('root.study_details', {
              accessToken: self.accessToken,
              sdate: $filter(constantStrings.DATE_OBJECT_TYPE)(sdate, constantStrings.DefaultStudyDateUrlFormat)
            });
          }
        };

        self.checkIfOffline = async function () {
          let isOffline = false;
          if (!signalrService.isConnected) {
            await modalService.showAlertAsync(constantStrings.DefaultOfflineAlertMessage);
            if (!self.reconnectTimeout) {
              self.reconnectTimeout = setTimeout(() => {
                signalrService.tryReconnectAgain();
                clearTimeout(self.reconnectTimeout);
              }, constantStrings.DefaultTimeoutRetryOnOffline);
            }
            isOffline = true;
          }
          return isOffline;
        }

        self.changeDate = function () {

          let today = new Date();
          let yesterday = today.setDate(today.getDate() - 1);
          let minDate = new Date(1900, 1, 1);
          let maxDate = yesterday;

          let ipObj = {
            callback: function (val) {  //Mandatory
              if (!self.patient) {
                self.patient = {};
              }
              let date = new Date(val);
              if (date > maxDate) {
                date = maxDate;
              }
              else if (date < minDate) {
                date = minDate;
              }
              self.patient.DOB = date;
            },
            inputDate: self.patient && self.patient.DOB ? self.getPatientDOBAsDate() : new Date(),
            from: minDate,
            to: maxDate
          };

          ionicDatePicker.openDatePicker(ipObj);
        };

        self.validate = function () {
          self.checkEmailFormat();
          if (self.invalidEmailFormat) {
            modalService.showAlert('Email Address has invalid format.');
            return false;
          }
          if (!self.patient || !self.patient.DOB || !self.patient.LastName || !self.patient.FirstName || !self.patient.Sex || !self.validatePhoneNumbers()) {
            return false;
          }
          return true;
        };

        self.validatePhoneNumbers = function () {
          self.isHomePhoneValid = self.validatePhoneNumber(self.patient.HomePhone);
          self.isCellPhoneValid = self.validatePhoneNumber(self.patient.CellPhone);
          self.isWorkPhoneValid = self.validatePhoneNumber(self.patient.WorkPhone);
          let isValid = self.isHomePhoneValid && self.isCellPhoneValid && self.isWorkPhoneValid;
          return isValid;
        }

        self.validatePhoneNumber = function (phoneNumber) {
          let isValid = true;
          if (phoneNumber !== undefined) {
            let phone = phoneNumber.replace(/\D/g, '');
            if (phone.length > 0 && phone.length !== 10) {
              isValid = false;
            }
          }
          return isValid;
        }

        self.goBack = function () {
          if (self.checkForChanges()) {
            modalService.showConfirmation(new function () {
            }, 'You have unsaved changes, are you sure you want to revert them?')
              .then((resp) => {
                if (resp) {
                  $state.go('root.patients');
                }
              });
          } else {
            $state.go('root.patients');
          }
        };


        self.openOutsideStudy = async function (study, $event) {
          const isOffline = await self.checkIfOffline();
          if (isOffline) {
            return;
          }

          if (self.checkForChanges()) {
            modalService.showConfirmation(null, constantStrings.DefaultRevertChangesConfirmationMessage)
              .then((confirmed) => {
                if (confirmed) {
                  $state.go('root.otherStudyDetails', {
                    worklistId: '',
                    ssn: study.Ssn,
                    returnStateParams: $state.params.accessToken,
                    studyId: study.Id
                  });
                }
              });
          } else {
            $state.go('root.otherStudyDetails', {
              worklistId: '',
              ssn: study.Ssn,
              returnStateParams: $state.params.accessToken,
              studyId: study.Id
            });
          }
          if ($event) {
            $event.preventDefault();
          }
        };

        self.addOutsideStudyBySsn = function ($event) {
          if (self.patient && self.patient.Ssn) {
            $state.go('root.otherStudyDetails', {
              worklistId: '',
              ssn: self.patient.Ssn,
              returnStateParams: $state.params.accessToken
            });
            $event.preventDefault();
          } else {
            modalService.showAlert('Patient SSN is not available');
          }
        };

        self.checkForChanges = function () {
          return JSON.stringify(angular.copy(self.patient)) !== JSON.stringify(self.patientCopy);
        };

        self.checkIfModelChanged = function (modal) {
          if (self.checkForChanges()) {
            modalService.showConfirmation(new function () {
            }, 'You have unsaved changes, are you sure you want to revert them?')
              .then((resp) => {
                if (resp) {
                  modal.hide();
                }
              });
          } else {
            modal.hide();
            if (self.wasSaved || !angular.equals(self.ClipboardFlagTitle, self.ClipboardFlagTitleCopy)) {
              self.callback && typeof self.callback === "function" && self.callback();
            }
          }
        };

        self.getAge = function () {
          let age;

          if (self.patient && self.patient.DOB) {

            let birthDate = self.getPatientDOBAsDate();

            age = ageHelper.getAgeFromBirthDate(birthDate);

          } else {
            age = '';
          }

          return age;
        };

        self.checkEmailFormat = function () {
          var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          self.invalidEmailFormat = self.patient.Email && !re.test(String(self.patient.Email).toLowerCase());
        };

        self.isValidEmailFormat = function (email) {
          var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return email && re.test(String(email).toLowerCase());
        };

        self.checkEmailExist = async function (email) {

          //self.techpadSettings.IsAllowedToChangePatientsData
          self.isCheckingEmailExist = true;
          const resp = await Patient.checkPatientEmail(email);
          const isEmailExist = resp && resp.data === true;

          self.isCheckingEmailExist = false;
          if (isEmailExist) {
            modalService.showAlert('Email already exists.');
            return false;
          } else {
            modalService.showAlert('Email is valid.');
            return true;
          }
        };

        self.getStateName = function (code) {
          const state = this.statesList.find(x => x.code === code);
          return state && state.name;
        };

        self.editRefPhy = async function () {
          $ionicLoading.show({
            template: 'Loading...'
          });

          let model = new PatientReferringPhysiciansDialogModel(self.patient);

          let closeByButtonsClickOnly = true;

          $ionicLoading.hide();
          await modalService.showDialogWindow('views/templates/patientReferringPhysiciansDialog.html', model, closeByButtonsClickOnly);
        };

        self.formatPhoneValue = function (phone) {
          let phoneNumber = phone;
          let result;
          phoneNumber = phoneNumber.replace(/\D/g, '');
          let operatorCode = phoneNumber.substring(0, 3);
          let firstThreeDigits = phoneNumber.substring(3, 6);
          let lastFourDigits = phoneNumber.substring(6, 10);
          if (operatorCode.length == 3 && firstThreeDigits.length > 0) {
            result = "(" + operatorCode + ") ";
            result += firstThreeDigits;
            if (lastFourDigits.length > 0) {
              result += "-" + lastFourDigits;
            }
          } else {
            result = phoneNumber;
          }
          return result;
        }

        self.getLookupByKey = function (array, key) {
          let el = (array || []).find(function (element) {
            return element.Key === key;
          });
          return el;
        }

        self.showRiskOOWarn = async function () {
          const isConfirmed = await modalService.showConfirmationAsync(
            "Proceeding will prevent the risk calculation for the current patient. Are you sure you want to continue?"
          );
          if (isConfirmed) {
            self.patient.IsRiskOptIn = true;
            return;
          }
          self.patient.IsRiskOptIn = null;
        };

        self.loadStudies = async function () {
          const response = await Patient.getPatientStudies(self.patient.Ssn);
          self.studies = response.data;

          self.studiesLoaded = true;
        };

        self.loadLocations = async function () {
          const resp = await Worklist.getAllLocations();
          self.locations = resp.data;
        }

        self.setStudies = async function () {
          if (!self.studies){
            return null;
          }

          const resp = await Worklist.getVisitReasons();
          self.visitReasons = resp.data;

          const studiesToDisplay = StudyDisplayHelpers.transformStudiesForDisplay(self.studies, {
            locations: self.locations,
            visitTypes: enums.visitTypes,
            visitReasons: self.visitReasons,
            dStatusTypes: enums.dStatusType,
            biRads: enums.biRads,
            procTypes: self.procTypes,
            viewsTypes: self.viewsTypes,
          });

          self.studiesToDisplay  =  studiesToDisplay;
        }

        self.viewReport = async function (study) {
          let document = null;
          try {
            document = await documentsSvc.getRadReportBySsnAndSDate(study.Ssn, study.SDate);
          } catch (error) {
            modalService.showAlert(
              commonConstants.STUDY_REPORT_UNAVAILABLE,
              undefined,
              undefined,
              commonConstants.REPORT_UNAVAILABLE,
              commonConstants.advancedConfirmationCancelButtonText
            );
            return;
          }
          await self.showDocument(document.data);
        };
  
        self.showDocument = async function (document) {
          if (document.Id && self.isOnline()) {
            if (document.DocumentSource === commonConstants.CONTACT_DOCUMENT_SOURCE) {
              await self.addContactDocument(document.Id);
            } else {
              $ionicLoading.show({
                template: commonConstants.DOCUMENT_LOADING_MESSAGE
              });
  
              try {
                let url = await documentsSvc.getDocumentUrl(document);
                if (techpadInitialConfigProvider.setFromElectron) {
                  documentPrintHelper.openDocumentElectron(url);
                } else {
                  documentPrintHelper.openDocumentBrowser(url, document, {
                    patient: self.patient,
                  });
                }
              } catch (resp) {
                modalService.showErrorMessage(resp.data, resp.status);
                $ionicLoading.hide();
              }
            }
          }
        };
      };

      return patientDetailsViewModel;
    }
  ]);



// WEBPACK FOOTER //
// ./src/scripts/models/patientDetails.js